<div id="loading"
[ngStyle]="{'border-color': color,'height' : radius + 'px','width' : radius + 'px'}">
</div> 
